import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TransformationService } from '../../services/TransformationService';

@Directive({
  selector: '[appBidAmount]',
  standalone: false
})
export class BidAmountDirective {
  @Input() bidWithDecimals = false;

  constructor(private control: NgControl, private transformationService:TransformationService) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const cleaned = this.transformationService.bidValuesOnly(currentValue, this.bidWithDecimals);
    
    if (cleaned !== currentValue) {
      const cursorPos = input.selectionStart || 0;
      const lengthDiff = (cleaned?.length || 0) - currentValue.length;
      
      this.control.control?.setValue(cleaned, { emitEvent: false });
      
      setTimeout(() => {
        const newPos = Math.max(0, cursorPos + lengthDiff);
        input.setSelectionRange(newPos, newPos);
      }, 0);
    }
  }
}